<template>
  <div id="error">

    <section style="padding: 10px;">
      <p>
        {{ $t('message.pleasetrytologinlater') }}
        <a
          href="javascript: void(0)"
          @click="$store.dispatch('Logout')">Login</a>
      </p>
    </section>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ErrorPage',
  beforeMount: function () {
    // set section
    this.$store.dispatch('setSection', 'error')
  },
}
</script>



// WEBPACK FOOTER //
// src/components/error/Error.vue